<template>
  <div class="single-segment-news" :id="segment_news.slug">
    <div  
      class="single-segment-news-content"
      :class="{ 
          'image-left': segment_news.image_side == 'L', 
          'image-right': segment_news.image_side == 'R',
          'allegro-smart': segment_news.slug == 'allegro-smart-dla-wszystkich'
      }"
      :style="{ 'background-color': segment_news.background_color }">
      
      <div class="single-segment-news__copy">
          <h2 class="copy__title" v-html="segment_news.title"></h2>
          <div class="copy__itself" v-html="segment_news.copy"></div>
          
          <template v-if="segment_news.cta">
              <a v-if="segment_news.url" target="_blank" class="copy__cta-url" :href="segment_news.url">{{ segment_news.cta }}</a>
            <a v-if="!segment_news.url" @click.prevent="toggleMoreCopy()" target="_blank" class="copy__cta-url" href="#">{{ segment_news.cta }}</a>
          </template>


      </div>

      <div class="single-segment-news__bg" :style="{ 'background-image': 'url(' + segment_news.image_path + ')' }">
          <img v-if="segment_news.slug == 'allegro-smart-dla-wszystkich'" class="allegro-smart-logo" src="@/assets/images/allegro-smart.png" alt="Allegro Smart" />
      </div>

    </div>
  
    <div v-if="is_streched" class="single-segment-news-more">
      <div class="more-copy" v-html="segment_news.copy_more"></div> 
      <a class="copy-less" @click.prevent="toggleMoreCopy()" href="">Zwiń</a>
    </div>

  </div>
</template>

<script>
  export default {
    props: ['segment_news'],
    data() {
      return {
        is_streched: false
      }
    },
    methods: {
      toggleMoreCopy: function () {
        this.is_streched = !this.is_streched
      }
    }
  };
</script>

<style lang="scss" scoped>

  .single-segment-news {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 20px;
    /* min-height: 300px; */

      @media only screen and (max-width : 991px) {
        width: calc(50% - 12px);
        background: #fff !important;
      }

      @media only screen and (max-width : 768px) {
        width: 100%;
        min-height: auto;
      }

      .single-segment-news-more {
        background: #fff;
        padding: 20px 60px;

        @media only screen and (max-width : 991px) {
          padding: 20px 20px;
        }

        .more-copy {
          color: #3E4E57;
          font-size: 18px;
          line-height: 28px;
          font-weight: 300;
          margin-bottom: 20px;
          text-align: left;

          & >>> p a {
            color: #00A790;
            font-size: 18px;
            line-height: 28px;
            font-weight: 600;
            text-decoration: none;

            &:hover {
              color: darken(#00A790, 5%);
            }
          }

          @media only screen and (max-width : 768px) {
                font-size: 14px;
                line-height: 22px;
            }
        }

        .copy-less {
          color: #00A790;
          font-size: 18px;
          line-height: 28px;
          font-weight: 600;
          text-decoration: none;
          position: relative;

          &:hover {
            color: darken(#00A790, 5%);

            &:after, &:before {
              background: darken(#00A790, 5%);
            }
          }

          &:before {
            content: "";
            width: 14px;
            height: 2px;
            background: #00A790;

            position: absolute;
            top: 12px;
            right: -22px;
            transform: rotate(45deg);
          }

          &:after {
            content: "";
            width: 14px;
            height: 2px;
            background: #00A790;

            position: absolute;
            top: 12px;
            right: -22px;
            transform: rotate(-45deg);
          }
          
        }
      }

      .single-segment-news-content {
        background: #fff;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;

        @media only screen and (max-width : 768px) {
          width: 100%;
          min-height: auto;
        }

        &.image-left {
        .single-segment-news__copy {
            order: 2;
        }

        .single-segment-news__bg {
            order: 1;
        }
        }

        &.image-right {
        .single-segment-news__copy {
            order: 1;
        }

        .single-segment-news__bg {
            order: 2;
        }
        }

        &.allegro-smart {
        background: url("../assets/images/smart-bg.png");
        background-repeat: no-repeat;
        background-position: calc(100%) 100%;
        background-size: contain;
        position: relative;

        @media only screen and (max-width : 1360px) {
            background-position: calc(100% + 100px) 100%;
        }

        @media only screen and (max-width : 1240px) {
            background: none;

            .single-segment-news__bg {
            background: #422177;
            }
        }

        img.allegro-smart-logo {
            position: absolute;
            top: 50%;
            right: 100px;
            transform: translateY(-50%);
            width: 220px;

            @media only screen and (max-width : 1240px) {
            top: 50%;
            right: initial;
            left: 76%;
            transform: translateX(-50%) translateY(-50%);
            }
        }
        }

        .single-segment-news__copy {
        width: 51%;
        padding: 45px 60px;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: center;

        @media only screen and (max-width : 991px) {
            width: 100%;
            padding: 20px;
            justify-content: flex-start;
        }

        h2 {
            color: #FF5A00;
            font-size: 28px;
            line-height: 34px;
            font-weight: 400;
            margin-bottom: 20px;

            @media only screen and (max-width : 768px) {
                font-size: 18px;
                line-height: 22px;
            }
        }

        .copy__itself {
            color: #3E4E57;
            font-size: 18px;
            line-height: 28px;
            font-weight: 300;
            margin-bottom: 20px;
            width: 75%;

            @media only screen and (max-width : 1200px) {
              width: 85%;
            }

            @media only screen and (max-width : 768px) {
                font-size: 14px;
                line-height: 22px;
	        }
        }

        a.copy__cta-url {
            color: #00A790;
            font-size: 18px;
            line-height: 28px;
            font-weight: 600;
            text-decoration: none;

            &:hover {
            color: darken(#00A790, 5%);
            }

            @media only screen and (max-width : 991px) {
            margin-top: auto;
            }

            @media only screen and (max-width : 768px) {
                font-size: 14px;
                line-height: 22px;
            }
        }
        }

        .single-segment-news__bg {
        width: 49%;
        background-position: 50% 100%;
        background-size: cover;
        background-repeat: no-repeat;

        @media only screen and (max-width : 991px) {
            display: none;
        }
        }
    }
  }
</style>